var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.blogComments),function(blogComment){return _c('blog-comment',{key:blogComment.id,attrs:{"comment":blogComment.comment,"name":blogComment.name,"time":blogComment.time,"date":blogComment.date}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }